import { render, staticRenderFns } from "./AssociationHistoryPagination.vue?vue&type=template&id=eb6a5ec8"
import script from "./AssociationHistoryPagination.vue?vue&type=script&lang=js"
export * from "./AssociationHistoryPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports